export class Dropdown {
  public items = [];
}